"use client";

import * as amplitude from "@amplitude/analytics-browser";
import { sessionReplayPlugin } from "@amplitude/plugin-session-replay-browser";

async function initAmplitude() {
  const sessionReplayTracking = sessionReplayPlugin();
  amplitude.add(sessionReplayTracking);
  await amplitude.init(process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY, {
    fetchRemoteConfig: true,
    autocapture: {
      pageViews: true,
      sessions: true,
      elementInteractions: true,
      fileDownloads: true,
      formInteractions: true,
      networkTracking: true,
      webVitals: true,
      frustrationInteractions: true,
    },
  }).promise;
}

const isProduction = process.env.NEXT_PUBLIC_ENVIRONMENT === 'production';
if (typeof window !== "undefined" && isProduction) {
  initAmplitude();
}

export const Amplitude = () => null;

export default amplitude;
